(function () {
  'use strict';
  if (window.__pedalInsiderBundleBound) return;
  window.__pedalInsiderBundleBound = true;

  var TEXT_BUSY = 'Adding your Let’s Rip Bundle...';
  var TEXT_ERROR = 'Sorry, the Let’s Rip Bundle could not be added.';
  var TEXT_ONE = 'Your cart already has a Let’s Rip Bundle (one per order). You can add this bag on its own.';
  var TEXT_KIT = 'Your cart has the Let’s Rip Kit. One Let’s Rip offer per checkout: check out your kit first, then come back for the Let’s Rip Bundle. You can add this bag on its own.';
  var UPGRADE_HANDLE = 'insider-bundle-upgrade';
  var KIT_HANDLES = ['insider-included', 'insider-kit-team-included'];
  var bundleState = null;
  var kitState = null;
  var readSeq = 0;
  var appliedSeq = 0;
  var localSeq = 0;
  var lastNudge = '';
  var refreshTimer = null;
  var listening = false;
  var instances = [];
  var escAt = 0;
  var escDialog = null;
  var escTrigger = null;

  function trim(v) {
    return String(v == null ? '' : v).replace(/^\s+|\s+$/g, '');
  }

  function own(o, k) {
    return Object.prototype.hasOwnProperty.call(o, k);
  }

  function makeGroupId() {
    var rand = (Math.random().toString(36) + '00000000000').substr(2, 9).toUpperCase();
    return 'IB-' + Date.now() + '-' + rand;
  }

  function sizeFor(cfg, variantId) {
    if (!cfg || !cfg.sizes || variantId == null) return null;
    var s = cfg.sizes[String(variantId)];
    if (!s || !cfg.upgrade || !cfg.upgrade[s]) return null;
    return s;
  }

  function shouldOffer(cfg, variantId, qty, names) {
    if (!sizeFor(cfg, variantId)) return false;
    if (parseInt(qty, 10) !== 1) return false;
    return (names || []).length <= 1;
  }

  function cleanName(raw, max) {
    var limit = parseInt(max, 10) > 0 ? parseInt(max, 10) : 30;
    var s = trim(String(raw == null ? '' : raw).toUpperCase().replace(/[,<>"']/g, ''));
    if (s.length > limit) s = trim(s.substr(0, limit));
    return s;
  }

  function namesOf(raw) {
    var out = [];
    var parts = String(raw == null ? '' : raw).split(',');
    for (var i = 0; i < parts.length; i++) {
      var p = trim(parts[i]);
      if (p) out.push(p);
    }
    return out;
  }

  function collectBagProps(form) {
    var props = {};
    var inputs = form.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.disabled) continue;
      if ((inp.type === 'checkbox' || inp.type === 'radio') && !inp.checked) continue;
      var m = String(inp.name || '').match(/^properties\[(.+)\]$/);
      if (!m) continue;
      var key = m[1];
      if (key === 'Custom Name' || key === '_Order_ID' || key === '_pro_bundle' || key === '_insider_bundle') continue;
      props[key] = inp.value;
    }
    return props;
  }

  function formField(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el) return el;
    var els = form.elements;
    var n = els && typeof els.namedItem === 'function' ? els.namedItem(name) : null;
    if (n && !n.tagName && n.length) n = n[0];
    return n || null;
  }

  function readSelection(form) {
    var idEl = form.querySelector('[name="id"][data-current-variant]') || form.querySelector('[name="id"]');
    var qEl = formField(form, 'quantity');
    var nEl = form.querySelector('#custom-name');
    var qty = qEl ? parseInt(qEl.value, 10) : 1;
    if (!(qty > 0)) qty = 1;
    return { variantId: idEl ? String(idEl.value) : '', qty: qty, names: namesOf(nEl ? nEl.value : '') };
  }

  function buildItems(cfg, o) {
    var id = o.groupId;
    var up = cfg.upgrade[sizeFor(cfg, o.bagVariantId)];
    var bagProps = {};
    var base = o.baseProps || {};
    for (var k in base) {
      if (own(base, k)) bagProps[k] = base[k];
    }
    if (o.name) bagProps['Custom Name'] = o.name;
    bagProps._Order_ID = id;
    bagProps._insider_bundle = id;
    var upProps = { _Order_ID: id, _insider_bundle: id, _ib_tee: String(o.teeVariantId), _ib_cal: String(o.calendarVariantId), _ib_bot: String(cfg.bottlesVariantId) };
    var items = [
      { id: Number(cfg.bottlesVariantId), quantity: 1, properties: { _insider_bundle: id } },
      { id: Number(o.calendarVariantId), quantity: 1, properties: { _insider_bundle: id } },
      { id: Number(o.teeVariantId), quantity: 1, properties: { _insider_bundle: id } },
      {
        id: Number(up.id),
        quantity: 1,
        properties: upProps
      },
      { id: Number(o.bagVariantId), quantity: 1, properties: bagProps }
    ];
    var book = Number(cfg.bookVariantId);
    if (book > 0) {
      upProps._ib_book = String(book);
      items.unshift({ id: book, quantity: 1, properties: { _insider_bundle: id } });
    }
    return items;
  }

  function hasGroup(cart, groupId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (groupId && items[i].properties && items[i].properties._insider_bundle === groupId) return true;
    }
    return false;
  }

  function bundleLines(cart) {
    var items = (cart && cart.items) || [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it && it.handle === UPGRADE_HANDLE && it.properties && it.properties._insider_bundle) out.push(it);
    }
    return out;
  }

  function bundleGroups(cart) {
    var lines = bundleLines(cart);
    var ids = [];
    for (var i = 0; i < lines.length; i++) {
      var id = lines[i].properties._insider_bundle;
      if (ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function kitInCart(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var p = (it && it.properties) || {};
      if (!it || p._insider_bundle) continue;
      if (KIT_HANDLES.indexOf(String(it.handle)) !== -1 || p._insider_kit_gift) return true;
    }
    return false;
  }

  function bundleUnits(cart) {
    var lines = bundleLines(cart);
    var n = 0;
    for (var i = 0; i < lines.length; i++) {
      var q = Number(lines[i].quantity);
      n += q > 0 ? q : 1;
    }
    return n;
  }

  function escScoped(target, dialog, trigger) {
    if (!target) return false;
    if (trigger && target === trigger) return true;
    return !!(dialog && dialog.contains && dialog.contains(target));
  }

  function isTeamTee(cfg) {
    return !!(cfg && cfg.tee && cfg.tee.team === true && cfg.tee.options && cfg.tee.options.length);
  }

  function teeOptions(cfg) {
    if (!cfg || !cfg.tee) return [];
    if (isTeamTee(cfg)) return cfg.tee.options;
    return [{ productId: cfg.tee.productId, label: '', image: '', min: '', minTotal: '', variants: cfg.tee.variants || [] }];
  }

  function teeChoice(cfg, optIndex, variantId) {
    var opts = teeOptions(cfg);
    var o = opts[optIndex] || opts[0];
    if (!o) return null;
    if (variantId) {
      var vs = o.variants || [];
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(variantId)) return { money: vs[i].money || '', total: vs[i].total || '' };
      }
    }
    return { money: o.min || '', total: o.minTotal || '' };
  }

  window.PedalInsiderBundle = {
    isTeamTee: isTeamTee,
    teeOptions: teeOptions,
    teeChoice: teeChoice,
    hasGroup: hasGroup,
    bundleGroups: bundleGroups,
    kitInCart: kitInCart,
    bundleUnits: bundleUnits,
    escScoped: escScoped,
    makeGroupId: makeGroupId,
    sizeFor: sizeFor,
    shouldOffer: shouldOffer,
    cleanName: cleanName,
    buildItems: buildItems,
    collectBagProps: collectBagProps,
    readSelection: readSelection
  };

  function readJson(el) {
    try { return JSON.parse((el && el.textContent) || ''); } catch (e) { return null; }
  }

  function all(el, sel) {
    return Array.prototype.slice.call(el.querySelectorAll(sel) || []);
  }

  function on(el, type, fn) {
    if (el) el.addEventListener(type, fn);
  }

  function setText(list, text) {
    list.forEach(function (el) { el.textContent = text; });
  }

  function clearName(form, surface) {
    var hidden = form.querySelector('#custom-name');
    var editor = form.querySelector('#custom-name-editor');
    var ph = form.querySelector('.Product2025CustomNamePlaceholder');
    if (hidden) hidden.value = '';
    if (editor) {
      if (editor.tagName === 'INPUT' || editor.tagName === 'TEXTAREA') editor.value = '';
      else editor.textContent = '';
    }
    if (ph && ph.style) ph.style.display = 'block';
    if (surface === 'custom-name') {
      var chk = form.querySelector('#custom-name-check');
      if (chk) chk.checked = false;
    }
  }

  function postItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      return r.text();
    }).then(function (t) {
      var j = JSON.parse(t);
      if (!j || !j.items) throw new Error('add failed');
      return j;
    });
  }

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart read failed ' + r.status);
        return r.json();
      });
  }

  function cartHasGroup(groupId) {
    return readCart().then(function (cart) { return hasGroup(cart, groupId); });
  }

  function refresh() {
    var mine = ++readSeq;
    var local = localSeq;
    return readCart().then(function (cart) {
      if (mine < appliedSeq || local !== localSeq) return;
      appliedSeq = mine;
      bundleState = bundleGroups(cart).length > 0;
      kitState = kitInCart(cart);
      if (bundleUnits(cart) > 1) {
        var sig = bundleGroups(cart).slice().sort().join('|');
        if (sig !== lastNudge) {
          lastNudge = sig;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      }
    }, function () {});
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refresh();
    }, 250);
  }

  function lockScroll(on2) {
    var h = document.documentElement;
    if (h && h.classList) h.classList[on2 ? 'add' : 'remove']('ibb-open');
  }

  function fitViewport(inst) {
    var st = inst.dialog && inst.dialog.style;
    if (!st || typeof st.setProperty !== 'function') return false;
    var vv = window.visualViewport;
    if (!vv || !inst.isOpen) {
      st.removeProperty('--ibb-vvh');
      st.removeProperty('--ibb-vvt');
      return false;
    }
    var was = st.getPropertyValue('--ibb-vvh');
    var h = Math.round(vv.height) + 'px';
    st.setProperty('--ibb-vvh', h);
    st.setProperty('--ibb-vvt', Math.round(vv.offsetTop) + 'px');
    return was !== h;
  }

  function reveal(inst, els) {
    var body = inst.el.body;
    if (!body || typeof body.getBoundingClientRect !== 'function') return;
    var top = Infinity;
    var bottom = -Infinity;
    els.forEach(function (el) {
      if (!el || el.hidden || typeof el.getBoundingClientRect !== 'function') return;
      var r = el.getBoundingClientRect();
      if (r.top < top) top = r.top;
      if (r.bottom > bottom) bottom = r.bottom;
    });
    if (top === Infinity) return;
    var b = body.getBoundingClientRect();
    var pad = 12;
    if (bottom > b.bottom - pad) body.scrollTop += Math.min(bottom - b.bottom + pad, top - b.top - pad);
    else if (top < b.top + pad) body.scrollTop -= b.top + pad - top;
  }

  function keepFieldVisible(inst) {
    var a = document.activeElement;
    if (!a || !inst.dialog.contains || !inst.dialog.contains(a)) return;
    if (!/^(INPUT|SELECT|TEXTAREA)$/.test(a.tagName || '') || typeof a.scrollIntoView !== 'function') return;
    try { a.scrollIntoView({ block: 'nearest' }); } catch (e) { a.scrollIntoView(false); }
  }

  function onViewportResize() {
    for (var i = 0; i < instances.length; i++) {
      if (!instances[i].isOpen) continue;
      if (fitViewport(instances[i])) keepFieldVisible(instances[i]);
    }
  }

  function onViewportScroll() {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].isOpen) fitViewport(instances[i]);
    }
  }

  function setStatus(inst, text) {
    if (inst.el.status) inst.el.status.textContent = text || '';
  }

  function setBusy(inst, busy) {
    inst.busy = busy;
    if (inst.el.yes) inst.el.yes.disabled = busy;
    if (inst.el.no) inst.el.no.disabled = busy;
    if (busy) inst.dialog.setAttribute('aria-busy', 'true');
    else inst.dialog.removeAttribute('aria-busy');
  }

  function setHint(inst) {
    if (inst.el.nameHint && inst.el.name) inst.el.nameHint.hidden = !trim(inst.el.name.value);
  }

  function showTeeErr(inst, show) {
    if (inst.el.teeErr) inst.el.teeErr.hidden = !show;
    if (inst.el.tee) {
      if (show) inst.el.tee.setAttribute('aria-invalid', 'true');
      else inst.el.tee.removeAttribute('aria-invalid');
    }
  }

  function currentOption(inst) {
    var opts = (inst.cfg.calendar && inst.cfg.calendar.options) || [];
    return opts[inst.color] || opts[0] || null;
  }

  function calendarVariant(inst) {
    var o = currentOption(inst);
    var vs = (o && o.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].size === inst.calSize) return vs[i];
    }
    return vs[0] || null;
  }

  function paintCalendar(inst) {
    var o = currentOption(inst);
    var vs = (o && o.variants) || [];
    var sizes = {};
    vs.forEach(function (v) { if (v.size) sizes[v.size] = true; });
    if (!sizes[inst.calSize]) inst.calSize = sizes.GIANT ? 'GIANT' : (sizes.MEDIUM ? 'MEDIUM' : inst.calSize);
    all(inst.dialog, '[data-ibb-color]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-ibb-color'), 10) === inst.color));
    });
    var any = false;
    all(inst.dialog, '[data-ibb-size-opt]').forEach(function (b) {
      var s = b.getAttribute('data-ibb-size-opt');
      var ok = !!sizes[s];
      any = any || ok;
      b.disabled = !ok;
      b.setAttribute('aria-pressed', String(ok && s === inst.calSize));
    });
    if (inst.el.sizeGroup) inst.el.sizeGroup.hidden = !any;
    if (inst.el.colorName && o) inst.el.colorName.textContent = o.color || '';
    setImage(inst.el.calImg, o && o.image);
  }

  function setImage(img, src) {
    if (!img || !src || img.getAttribute('src') === src) return;
    img.setAttribute('src', src);
  }

  function paintTeePrice(inst) {
    var ch = teeChoice(inst.cfg, inst.tee, inst.el.tee ? inst.el.tee.value : '');
    if (!ch) return;
    setText(all(inst.dialog, '[data-ibb-tee-price]'), ch.money);
    setText(all(inst.dialog, '[data-ibb-gear-total]'), ch.total);
  }

  function paintTee(inst) {
    if (!isTeamTee(inst.cfg)) return;
    var opts = teeOptions(inst.cfg);
    var o = opts[inst.tee] || opts[0];
    all(inst.dialog, '[data-ibb-tee-opt]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-ibb-tee-opt'), 10) === inst.tee));
    });
    if (inst.el.teeName) inst.el.teeName.textContent = o.label || '';
    setImage(inst.el.teeImg, o.image);
    var sel = inst.el.tee;
    if (sel) {
      while (sel.firstChild) sel.removeChild(sel.firstChild);
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Choose a size';
      sel.appendChild(ph);
      (o.variants || []).forEach(function (v) {
        var op = document.createElement('option');
        op.value = String(v.id);
        op.textContent = v.size;
        sel.appendChild(op);
      });
      sel.value = '';
    }
    paintTeePrice(inst);
  }

  function focusEl(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function openDialog(inst, btn, sel) {
    var cfg = inst.cfg;
    inst.trigger = btn;
    inst.size = sizeFor(cfg, sel.variantId);
    inst.variantId = sel.variantId;
    setText(all(inst.dialog, '[data-ibb-bump]'), cfg.upgrade[inst.size].money);
    setText(all(inst.dialog, '[data-ibb-size-label]'), (cfg.labels && cfg.labels[inst.size]) || inst.size);
    if (inst.el.name) inst.el.name.value = cleanName(sel.names[0] || '', cfg.nameMax);
    setHint(inst);
    if (inst.el.tee) inst.el.tee.value = '';
    showTeeErr(inst, false);
    inst.color = 0;
    inst.calSize = 'GIANT';
    inst.tee = 0;
    paintTee(inst);
    paintCalendar(inst);
    setStatus(inst, '');
    if (inst.el.bagOnly) inst.el.bagOnly.hidden = true;
    setBusy(inst, false);
    inst.isOpen = true;
    fitViewport(inst);
    var d = inst.dialog;
    if (typeof d.showModal === 'function') {
      if (!d.open) d.showModal();
    } else {
      d.setAttribute('open', '');
    }
    if (inst.el.body) inst.el.body.scrollTop = 0;
    lockScroll(true);
    focusEl(inst.el.yes);
  }

  function shut(inst) {
    var d = inst.dialog;
    inst.isOpen = false;
    try {
      if (typeof d.close === 'function') { if (d.open) d.close(); } else d.removeAttribute('open');
    } catch (e) {}
    fitViewport(inst);
    lockScroll(false);
  }

  function closeDialog(inst) {
    if (inst.busy) return;
    var b = inst.trigger;
    shut(inst);
    if (b && b.isConnected !== false) focusEl(b);
  }

  function added(inst) {
    localSeq += 1;
    bundleState = true;
    inst.pendingGroupId = null;
    setBusy(inst, false);
    setStatus(inst, '');
    shut(inst);
    clearName(inst.form, inst.surface);
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function passBag(inst) {
    var b = inst.trigger;
    shut(inst);
    if (!b) return;
    inst.passing = true;
    try { b.click(); } finally { inst.passing = false; }
  }

  function bagOnly(inst) {
    if (inst.busy) return;
    var gid = inst.pendingGroupId;
    if (!gid) { passBag(inst); return; }
    setBusy(inst, true);
    cartHasGroup(gid).then(function (has) {
      setBusy(inst, false);
      if (has) { added(inst); return; }
      passBag(inst);
    }, function () {
      setBusy(inst, false);
      passBag(inst);
    });
  }

  function yes(inst) {
    if (inst.busy) return;
    var tee = inst.el.tee && inst.el.tee.value;
    if (!tee) {
      showTeeErr(inst, true);
      reveal(inst, [inst.el.tee && inst.el.tee.previousElementSibling, inst.el.tee, inst.el.teeErr]);
      focusEl(inst.el.tee);
      return;
    }
    showTeeErr(inst, false);
    var cal = calendarVariant(inst);
    if (!cal) { setStatus(inst, TEXT_ERROR); return; }
    var items = buildItems(inst.cfg, {
      bagVariantId: inst.variantId,
      baseProps: collectBagProps(inst.form),
      name: cleanName(inst.el.name ? inst.el.name.value : '', inst.cfg.nameMax),
      teeVariantId: tee,
      calendarVariantId: cal.id,
      groupId: inst.pendingGroupId || (inst.pendingGroupId = makeGroupId())
    });
    var gid = inst.pendingGroupId;
    setBusy(inst, true);
    setStatus(inst, TEXT_BUSY);
    if (inst.el.bagOnly) inst.el.bagOnly.hidden = true;
    readCart().then(function (cart) {
      var ids = bundleGroups(cart);
      if (ids.indexOf(gid) !== -1) { added(inst); return; }
      if (kitInCart(cart)) { localSeq += 1; kitState = true; holdKit(inst); return; }
      if (ids.length) { refuse(inst); return; }
      send(inst, items, gid);
    }, function () {
      send(inst, items, gid);
    });
  }

  function refuse(inst) {
    localSeq += 1;
    bundleState = true;
    inst.pendingGroupId = null;
    setBusy(inst, false);
    setStatus(inst, TEXT_ONE);
    if (inst.el.bagOnly) inst.el.bagOnly.hidden = false;
  }

  function holdKit(inst) {
    inst.pendingGroupId = null;
    setBusy(inst, false);
    setStatus(inst, TEXT_KIT);
    if (inst.el.yes) inst.el.yes.disabled = true;
    if (inst.el.bagOnly) inst.el.bagOnly.hidden = false;
    focusEl(inst.el.bagOnly);
  }

  function send(inst, items, gid) {
    postItems(items).then(function () {
      added(inst);
    }).catch(function () {
      cartHasGroup(gid).then(function (has) {
        if (has) { added(inst); return; }
        setBusy(inst, false);
        setStatus(inst, TEXT_ERROR);
        if (inst.el.bagOnly) inst.el.bagOnly.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
      }, function () {
        setBusy(inst, false);
        setStatus(inst, TEXT_ERROR);
        if (inst.el.bagOnly) inst.el.bagOnly.hidden = true;
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
    });
  }

  function trapTab(inst, e) {
    if (e.key !== 'Tab') return;
    var f = all(inst.dialog, 'button, select, input, a[href]').filter(function (n) {
      return !n.disabled && !n.hidden && n.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); focusEl(first); }
  }

  function bind(root) {
    if (root.getAttribute('data-ibb-bound')) return;
    var form = root.closest('form');
    var cfg = readJson(root.querySelector('[data-ibb-config]'));
    var dialog = root.querySelector('[data-ibb-dialog]');
    if (!form || !cfg || !dialog) return;
    root.setAttribute('data-ibb-bound', 'true');
    if (document.body && dialog.parentNode !== document.body) document.body.appendChild(dialog);
    var q = function (s) { return dialog.querySelector(s); };
    var inst = {
      root: root, form: form, cfg: cfg, dialog: dialog, surface: root.getAttribute('data-ibb-surface') || '', passing: false, busy: false, isOpen: false,
      trigger: null, size: null, variantId: null, color: 0, tee: 0, calSize: 'GIANT', pendingGroupId: null,
      el: {
        yes: q('[data-ibb-yes]'), no: q('[data-ibb-no]'), close: q('[data-ibb-close]'), bagOnly: q('[data-ibb-bagonly]'),
        name: q('[data-ibb-name]'), nameHint: q('[data-ibb-name-hint]'), tee: q('[data-ibb-tee]'), teeErr: q('[data-ibb-tee-err]'),
        status: q('[data-ibb-status]'), colorName: q('[data-ibb-color-name]'), sizeGroup: q('[data-ibb-cal-size]'), teeName: q('[data-ibb-tee-name]'),
        teeImg: q('[data-ibb-tee-img]'), calImg: q('[data-ibb-cal-img]'), body: q('[data-ibb-body]')
      }
    };
    instances.push(inst);
    on(inst.el.yes, 'click', function () { yes(inst); });
    on(inst.el.no, 'click', function () { bagOnly(inst); });
    on(inst.el.bagOnly, 'click', function () { bagOnly(inst); });
    on(inst.el.close, 'click', function () { closeDialog(inst); });
    on(inst.el.name, 'input', function () { setHint(inst); });
    on(inst.el.tee, 'change', function () {
      if (inst.el.tee.value) showTeeErr(inst, false);
      if (isTeamTee(inst.cfg)) paintTeePrice(inst);
    });
    all(dialog, '[data-ibb-tee-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        inst.tee = parseInt(b.getAttribute('data-ibb-tee-opt'), 10) || 0;
        paintTee(inst);
      });
    });
    all(dialog, '[data-ibb-color]').forEach(function (b) {
      b.addEventListener('click', function () {
        inst.color = parseInt(b.getAttribute('data-ibb-color'), 10) || 0;
        paintCalendar(inst);
      });
    });
    all(dialog, '[data-ibb-size-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        inst.calSize = b.getAttribute('data-ibb-size-opt');
        paintCalendar(inst);
      });
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      escAt = Date.now();
      escDialog = dialog;
      escTrigger = inst.trigger;
      closeDialog(inst);
    });
    dialog.addEventListener('close', function () {
      if (inst.isOpen) { inst.isOpen = false; fitViewport(inst); lockScroll(false); }
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog(inst);
    });
    dialog.addEventListener('keydown', function (e) { trapTab(inst, e); });
  }

  window.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && escAt && Date.now() - escAt < 1500 && escScoped(e.target, escDialog, escTrigger)) {
      escAt = 0;
      e.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('button[name="add"]') : null;
    if (!btn) return;
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!inst.form.contains(btn)) continue;
      if (inst.passing || inst.busy || inst.isOpen) return;
      if (inst.form.querySelector('[data-sizechart-checkbox]:not(:checked)')) return;
      var sel = readSelection(inst.form);
      if (!shouldOffer(inst.cfg, sel.variantId, sel.qty, sel.names)) return;
      if (kitState === true) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        openDialog(inst, btn, sel);
        holdKit(inst);
        return;
      }
      if (bundleState === true) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      openDialog(inst, btn, sel);
      return;
    }
  }, true);

  function init() {
    var roots = document.querySelectorAll('[data-ibb]');
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
    if (!instances.length || listening) return;
    listening = true;
    ['cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (t) { document.addEventListener(t, scheduleRefresh); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) scheduleRefresh(); });
    window.addEventListener('pageshow', scheduleRefresh);
    var vv = window.visualViewport;
    if (vv && typeof vv.addEventListener === 'function') {
      vv.addEventListener('resize', onViewportResize);
      vv.addEventListener('scroll', onViewportScroll);
    }
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
